import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {CatalogsService} from '../../../services/catalogs.service';
import {IGeneric} from '../../../domain/IGeneric';
import {IAddress} from '../../../domain/IAddress';
import {Application} from '../../../domain/onBoarding/application';
import {ApplicationService} from '../../../services/application.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {CommonComponent} from '../../shared/common/common.component';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ApplicationBody, ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {KycResult} from '../../../domain/onBoarding/kycResult';
import {EKycStatus} from '../../../enums/EKycStatus';
import {CurpStatus, ICurpResponse} from '../../../domain/ICurpResponse';
import {ConfigurationService} from '../../../services/configuration.service';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.scss']
})
export class PersonalDataComponent extends CommonComponent implements OnInit {

  day: number = null;
  month: number = null;
  year: number = new Date().getFullYear();


  @ViewChild('blackListedModal', {static: true}) blackListedModal: TemplateRef<any>;
  noSSNRequireDPI = environment.noSSNRequireDPI;
  address: IAddress;
  application: Application;
  platform: string;
  today = moment();
  minDate: string;
  maxDate: string;
  cellPhoneValidate: boolean;
  selectState: IGeneric = null;
  selectCity: IGeneric = null;
  showCityField: boolean;
  uglyDateHolder: Date = null;
  months: string;
  usResident: boolean;
  mxResident: boolean;
  otherResident: boolean;
  curpRequired: boolean;
  refreshBirthday = true;
  states: IGeneric[];
  pronouns: IGeneric[];
  selectedState: IGeneric = null;
  selectedPronoun: IGeneric = null;
  emailLocal: string;
  hasDocuments: boolean;
  showAddressConfirmation: boolean;
  isChildFormValid = false;
  initialDate: any;

  constructor(
    protected router: Router,
    private applicationService: ApplicationService,
    private catalogsService: CatalogsService,
    public configurationService: ConfigurationService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;

    this.initialDate = this.application.body.dateOfBirth || this.application.body.ocrDateOfBirth;

    this.emailLocal = this.application.body.email;
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.resetChildForm();
        if ((this.application.body.ocrFieldsConfirm && this.application.body.dateOfBirth) ||
          (!this.application.body.ocrFieldsConfirm && this.application.body.ocrDateOfBirth)) {
          this.uglyDateHolder = new Date(this.isNullOrTrue(this.application.body.ocrFieldsConfirm) ?
            this.application.body.dateOfBirth : this.application.body.ocrDateOfBirth);
          this.uglyDateHolder.setTime(this.uglyDateHolder.getTime() + this.uglyDateHolder.getTimezoneOffset() * 60 * 1000);
        }
        this.getPronouns();
      });
  }

  onChildFormValid(valid: boolean) {
    this.isChildFormValid = valid;
  }

  ngOnInit(): void {
    this.months = this.translate.instant('shared.common.months', {Default: '"Enero, Febrero, Marzo, Abril, Mayo, Junio, Julio, Agosto,Septiembre,Octubre, Noviembre, Diciembre"'});
    this.maxDate = this.today.subtract(18, 'years').format('MM/DD/YYYY');
    this.minDate = this.today.subtract(100 - 18, 'years').format('MM/DD/YYYY');
    scroll(0, 0);
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    this.cellPhoneValidate = false;
    this.address = {
      state: [],
      city: []
    };
    if (this.application.body.dateOfBirth || this.application.body.ocrDateOfBirth) {
      this.uglyDateHolder = new Date(this.isNullOrTrue(this.application.body.ocrFieldsConfirm) ?
        this.application.body.dateOfBirth : this.application.body.ocrDateOfBirth);
      this.uglyDateHolder.setTime(this.uglyDateHolder.getTime() + this.uglyDateHolder.getTimezoneOffset() * 60 * 1000);
    }
    this.curpRequired = this.application.body.identificationCountry === 'MEXICO' || this.application.body.identification2Country === 'MEXICO';
    if (!this.curpRequired) {
      this.application.body.birthplace = null;
    } else {
      this.getBirthPlaces();
    }
    this.getPostalCodes();
    this.getPronouns();
    this.citizenshipEval();
    this.hasDocumentsEval();
  }

  onSubmit() {
    this.cleanNames();
    if (this.application.body.applicationRejected) {
      this.submitApp();
    } else {
      this.validateEmail();
    }
  }

  onBlackListedSubmit() {
    this.router.navigate(['/onboarding/end']);
  }
  changeBirthplace() {
    if (this.application.body.ocrFieldsConfirm == false) {
      this.application.body.ocrBirthplaceName = this.selectedState.id;
      this.application.body.ocrBirthplace = this.selectedState.value;
    } else {
      this.application.body.birthplace = this.selectedState.id;
      this.application.body.birthplaceName = this.selectedState.value;
    }
  }

  changePronoun() {
    this.application.body.pronoun = this.selectedPronoun.id;
    this.application.pronounTitle = this.selectedPronoun.title;
  }

  getBirthPlaces() {
    this.catalogsService.getStates().subscribe(
      (response: any) => {
        this.states = response;
        if (this.application.body.ocrFieldsConfirm === false){
          if (this.application.body.ocrBirthplaceName){
            this.selectedState = this.states.find(it => this.application.body.ocrBirthplaceName === it.id);
          }
        } else if (this.application.body.birthplace) {
          this.selectedState = this.states.find(it => this.application.body.birthplace === it.id);
        }
      }, error => {
        this.msgError(error);
      }
    );
  }
  getPronouns() {
    this.catalogsService.getPronouns().subscribe(
      (response: any) => {
        this.pronouns = response;
        if (this.application.recoveryToken || this.application.body.pronoun) {
          this.selectedPronoun = this.pronouns.find(it => this.application.body.pronoun === it.id);
          this.application.pronounTitle = this.selectedPronoun.title;
        }
      }, error => {
        this.msgError(error);
      }
    );
  }
  getPostalCodes() {
    if (this.application.body.postalCode) {
      this.address = {
        state: [],
        city: []
      };
      this.showCityField = false;
      this.loadingModalOn();
      this.catalogsService.getPostalCode(this.application.body.postalCode).subscribe(
        (response: any) => {
          const resp = this.reformatPostalCode(response);
          this.loadingModalOff();
          if (resp.state) {
            this.address.state = resp.state;
            this.selectState = this.address.state[0];
            this.onStateChanged();
          }

          if (resp.city) {
            if (resp.city.length === 1 && resp.city[0].value == null) {
              this.address.city = null;
            } else {
              this.address.city = resp.city;
              this.selectCity = this.address.city[0];
              this.onCityChanged();
            }
          }
        }, error => {
          this.loadingModalOff();
          this.msgError(error);
        }
      );
    }

  }

  citizenshipEval() {
    if (this.application.body.identificationCountry == '840') {
      this.usResident = true;
      this.mxResident = false;
      this.otherResident = false;
      this.application.body.secondLastName = null;
    } else if (this.application.body.identificationCountry == '484') {
      this.mxResident = true;
      this.usResident = false;
      this.otherResident = false;
    } else if (this.application.body.identificationCountry != '840' && this.application.body.identificationCountry != '484') {
      this.otherResident = true;
      this.usResident = false;
      this.mxResident = false;
    }
  }

  validateEmail() {
    const data = {
      email: this.emailLocal,
    };
    this.applicationService.sendOtp(data, 'email').subscribe(
      (response: any) => {
        this.submitApp();
      },
      error => {
        this.msgError(error);
        scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }
    );
  }

  submitApp() {
    if (!this.application.body.applicationRejected){
      this.application.body.email = this.emailLocal;
    }
    this.modalService.dismissAll();
    if (this.application.body.ocrFieldsConfirm === false) {
      this.application.body.firstName = this.application.body.ocrFirstName;
      this.application.body.additionalNames = this.application.body.ocrAdditionalNames;
      this.application.body.lastName = this.application.body.ocrLastName;
      this.application.body.secondLastName = this.application.body.ocrSecondLastName;
      this.application.body.dateOfBirth = this.application.body.ocrDateOfBirth;
      this.application.body.gender = this.application.body.ocrGender;
      this.application.body.birthplace = this.application.body.ocrBirthplaceName;
      this.application.body.birthplaceName = this.application.body.ocrBirthplace;
      this.application.body.ocrFieldsConfirm = true;
    }
    this.loadingModalOn();
    this.applicationService.setApplication().subscribe(
      (response: ApplicationBody) => {
        if (!this.application.body.applicationId) {
          this.application.body.applicationId = response.applicationId;
        }
        this.application.body.status = response.status;
        if (this.curpRequired && this.configurationService.application.validateCurp) {
          this.submitCURP();
        } else {
          this.submitKyc();
        }
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  submitCURP() {
    this.applicationService.saveCurp(this.application.body).subscribe(
      (response: ICurpResponse) => {
        switch (response.status) {
          case CurpStatus.DISABLED:
          case CurpStatus.SUCCESS:
            this.submitKyc();
            break;
          case CurpStatus.UNAVAILABLE:
          case CurpStatus.FAILED:
            this.loadingModalOff();
            this.msgWarning(this.translate.instant('onboarding.personal-data.curp-error-try-again', {Default: 'Los datos para generar tu CURP son incorrectos por favor verifícalos y vuelve a intentarlo'}));
            break;
          case CurpStatus.DENIED:
            this.loadingModalOff();
            this.application.body.status = ApplicationStatus.DENIED;
            this.router.navigate(['/onboarding/end']);
            break;
        }

      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }

  submitKyc() {
    let submit = true;
    if (this.isAmericanCitizen(this.application) && this.application.body.applicationRejected
      && this.configurationService.application.enableSelfieRequiered) {
      submit = false;
    }
    this.applicationService.submitKyc(this.application.body.applicationId, null).subscribe(
      (kycResult: KycResult) => {
        this.application.body.kycStatus = kycResult.kycStatus;
        this.loadingModalOff();
        switch (kycResult.kycStatus) {
          case EKycStatus.APPROVED:
          case EKycStatus.MANUAL_REVIEW:
            if (this.application.body.applicationRejected) {
              this.loadingModalOn();
              this.applicationService.setApplication(submit).subscribe(
                (response: ApplicationBody) => {
                  this.application.body.status = response.status;
                  this.loadingModalOff();
                  if (this.isAmericanCitizen(this.application) && this.configurationService.application.enableSelfieRequiered){
                      this.router.navigate(['/onboarding/selfie']);
                  } else {
                    this.router.navigate(['/onboarding/end']);
                  }
                }, error => {
                  this.loadingModalOff();
                  this.msgError(error);
                }
              );
            } else {
              if (this.isAmericanCitizen(this.application) && this.configurationService.application.enableSelfieRequiered){
                  this.router.navigate(['/onboarding/selfie']);
              } else {
                this.router.navigate(['/onboarding/contracts']);
              }
            }
            break;
          case EKycStatus.BLACK_LISTED:
            this.openModal(this.blackListedModal);
            break;
          case EKycStatus.PENDING_DOCUMENTS:
            this.router.navigate(['/onboarding/photos']);
            break;
          case EKycStatus.PENDING_QUESTIONS:
            this.application.body.cipQuestions = kycResult.cipResult.cipQuestions;
            this.application.cipQ = true;
            this.router.navigate(['/onboarding/additionalQuestions']);
            break;
          default:
            this.msgError(this.translate.instant('onboarding.contracts-consents.error-try-again', {Default: 'Hubo un problema al generar su aplicación, por favor vuelva a intentarlo'}));
            break;
        }
      }, error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  resetChildForm() {
    this.refreshBirthday = false;
    this.months = this.translate.instant('shared.common.months', {Default: '"Enero, Febrero, Marzo, Abril, Mayo, Junio, Julio, Agosto,Septiembre,Octubre, Noviembre, Diciembre"'});
    setTimeout(() => {
      this.refreshBirthday = true;
    }, 1);
  }

  onBirthdaySelection(uglyDate: Date) {
    if (!isNaN(new Date(uglyDate).getTime())) {
      return moment(uglyDate).format('YYYY-MM-DD');
    }
    return null;
  }

  onCityChanged() {
    if (this.selectCity) {
      this.application.body.city = this.selectCity.value;
      this.application.body.idCity = this.selectCity.id;
    }
  }

  onStateChanged() {
    if (this.selectState) {
      this.application.body.state = this.selectState.value;
      this.application.body.idState = this.selectState.id;
    }
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  hasDocumentsEval() {
    if (this.application.body.documents && this.application.body.documents.length > 0) {
      this.hasDocuments = true;
    } else if (this.application.identificationFront){
      this.hasDocuments = true;
    } else {
      this.hasDocuments = false;
    }
  }

  cleanNames(){
    this.application.body.ocrFirstName  = this.application.body.ocrFirstName?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.ocrAdditionalNames  = this.application.body.ocrAdditionalNames?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.ocrLastName  = this.application.body.ocrLastName?.replace(/\s\s+/g, ' ').trim();
    this.application.body.ocrSecondLastName  = this.application.body.ocrSecondLastName?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.firstName  = this.application.body.firstName?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.additionalNames  = this.application.body.additionalNames?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.lastName  = this.application.body.lastName?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.secondLastName  = this.application.body.secondLastName?.replace(/\s\s+/g, ' ').trim() || null;
    this.application.body.addressInteriorNumber  = this.application.body.addressInteriorNumber?.replace(/\s\s+/g, ' ').trim() || null;
  }

  onBack() {
    this.cleanNames();
    if (this.application.body.identificationNumber?.length !== 13) {
      this.application.body.identificationNumber = null;
    }
    if (this.isAmericanCitizen(this.application)) {
      this.router.navigate(['/onboarding/usaIds']);
    } else {
      this.router.navigate(['/onboarding/selfie']);
    }
  }

  updateOCRDateOfBirth(date: Date) {
    const DATE_CONVERTED = date.toISOString().split('T')[0];
    const TYPE_VALUE = this.application.body.ocrFieldsConfirm ? 'ocrDateOfBirth' : 'dateOfBirth';
    this.application.body[TYPE_VALUE] = DATE_CONVERTED;

    console.log('application.body', this.application.body);

  }

}
